// TODO Migrate this types to types directory

import { FShallowGraph, FShallowNode } from '../types/index.js';

export enum GraphActionType {
  Init = 'init',
  Load = 'load',
  Add = 'add',
  Update = 'update',
  Remove = 'remove',
  SetName = 'setName',
  SetSpace = 'setSpace',
}

export interface GraphInitAction {
  type: GraphActionType.Init;
  payload: FShallowGraph;
}

export interface GraphLoadAction {
  type: GraphActionType.Load;
  payload: FShallowGraph;
}

export interface GraphAddAction {
  type: GraphActionType.Add;
  payload: { selector: string; node: FShallowNode };
}

export interface GraphUpdateAction {
  type: GraphActionType.Update;
  payload: {
    selector: string;
    path: string;
    value: any;
  };
}

export interface GraphRemoveAction {
  type: GraphActionType.Remove;
  payload: {
    selector: string;
  };
}

export interface GraphSetNameAction {
  type: GraphActionType.SetName;
  payload: { name: string };
}

export interface GraphSetSpaceAction {
  type: GraphActionType.SetSpace;
  payload: { id: number };
}

export type GraphAction =
  | GraphInitAction
  | GraphLoadAction
  | GraphAddAction
  | GraphUpdateAction
  | GraphRemoveAction
  | GraphSetNameAction
  | GraphSetSpaceAction;
